import { BreAerialType } from '~/tenants/bre/performable/aerial/BreAerialConfig';

export const BreAerialData: Record<
  BreAerialType,
  {
    amount: TMoney;
    photos: number;
    onsite: number;
  }
> &
  Record<'poi' | 'poi_each', TMoney> = {
  [BreAerialType.FIVE]: {
    amount: '150.00',
    onsite: 15,
    photos: 5,
  },
  [BreAerialType.TEN]: {
    amount: '300.00',
    onsite: 30,
    photos: 10,
  },
  [BreAerialType.COMBO]: {
    amount: '500.00',
    onsite: 30,
    photos: 10,
  },
  [BreAerialType.VIDEO]: {
    amount: '300.00',
    onsite: 30,
    photos: 0,
  },
  [BreAerialType.TWILIGHT]: {
    amount: '300.00',
    onsite: 30,
    photos: 5,
  },
  poi: '125.00',
  poi_each: '25.00',
};

export default BreAerialData;
